import fitData from './modes/fitData.js';
import fitDataGeneral from './modes/fitDataGeneral.js';
import fitDataStretch from './modes/fitDataStretch.js';
import fitColumns from './modes/fitColumns.js';

export default {
	fitData:fitData,
	fitDataFill:fitDataGeneral,
	fitDataTable:fitDataGeneral,
	fitDataStretch:fitDataStretch,
	fitColumns:fitColumns ,
};